module.exports = __webpack_public_path__ + "static/img/banner_6.01162e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/banner_6.jpg
// module id = kjfc
// module chunks = 19